import { K3Extensions } from '@k3/core';
import { DeepRequired } from '../types/DeepRequired';
import { Checkbox, Tooltip } from '@mui/material';
import { VariableComponentProps } from '@k3/core/dist/src/lib/types/variableUiTypes';
import Box from '@mui/material/Box';

export const WrappedStageButton: DeepRequired<K3Extensions>['components']['switchCard'] =
  (Wrapped) => (props: VariableComponentProps) => {
    const handleOnChange = (event: unknown, checked: boolean) => {
      const checkedValue = checked ? '1' : '0';
      const value = props.values.find((v) => v.value === checkedValue);
      if (props.onChange && value) {
        props.onChange(value.id);
      }
    };

    return (
      <>
        <Wrapped {...props} />
        <Tooltip
          title={props.variable.label}
          arrow={true}
          placement={'top'}
          componentsProps={{
            arrow: {
              sx: {
                color: 'white !important',
              },
            },
            tooltip: {
              sx: {
                backgroundColor: '#fff',
                color: (theme) => theme.palette.text.primary,
              },
            },
          }}
        >
          <Box component={'div'}>
            <Checkbox
              sx={{
                backgroundColor: 'white !important',
                border: '2px solid transparent',
                borderRadius: 'calc(infinity * 1px)',
                width: '3rem',
                height: '3rem',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                justifyContent: 'center',
                alignItems: 'center',
                '&.Mui-checked': {
                  border: '2px solid',
                },
              }}
              onChange={handleOnChange}
              icon={props.children}
              checkedIcon={props.children}
            />
          </Box>
        </Tooltip>
      </>
    );
  };
